module.exports = __webpack_public_path__ + "static/media/Moldflow Adviser.867597b4.png";